import { cn } from '@/lib/utils'

interface SelectProps extends React.ComponentProps<'select'> {
	error?: string
}

export function Select({ error, className, children, ...props }: SelectProps) {
	return (
		<div className="flex flex-col gap-1">
			<select
				className={cn(
					'h-9 w-full rounded-md border border-border bg-card px-3 text-sm text-foreground',
					'focus:outline-none focus:border-primary',
					'disabled:cursor-not-allowed disabled:bg-muted disabled:text-muted-foreground',
					error && 'border-error focus:border-error',
					className,
				)}
				{...props}
			>
				{children}
			</select>
			{error && <span className="text-xs text-error">{error}</span>}
		</div>
	)
}
